// extracted by mini-css-extract-plugin
module.exports = {"content":"CollapsibleRichText_content__MbOCw","maxCharacterCount":"CollapsibleRichText_maxCharacterCount__tInWS","truncate":"CollapsibleRichText_truncate__50XSi"};